import { AppTheme } from '../constants';

export type ThemeBackgroundType = {
  poster: string,
  isAnimated: boolean,
  animationObjUrl?: string
}

export function getThemeBackground(
  isDefaultTheme: boolean, appTheme: AppTheme,
): ThemeBackgroundType {
  if (!isDefaultTheme) {
    return {
      poster: `assets/${appTheme}/images/dashboard-bg`,
      isAnimated: false,
    };
  }

  return {
    poster: 'assets/images/app-backgrounds/mountain-bg',
    isAnimated: false, // 👉 true when video background
  };
}
